import numeral from 'numeral'

import { config } from 'global/lib/config'

export function formatNumber(number: number, format: string = config.NUMBER.DEFAULT_FORMAT): string {
  return numeral(number).format(format)
}
